import { AppSidebar } from "@/components/layout/AppSidebar";
import { Navbar } from "@/components/layout/Navbar";
import { AppRoutes } from "@/components/routing/AppRoutes";

export function AppLayout() {
  return (
    <div className="min-h-screen flex w-full dark:bg-gray-950">
      <AppSidebar />
      <div className="flex-1 flex flex-col">
        <Navbar />
        <AppRoutes />
      </div>
    </div>
  );
}